const ingredientsWrap = document.querySelector(".embla.ingredients");

const ingredientsViewPort = ingredientsWrap.querySelector(".embla__viewport");
const ingredientsDots = document.querySelector(
  ".embla__dots.ingredients__dots"
);

const ingredientsEmbla = EmblaCarousel(ingredientsViewPort, {
  loop: false,
  skipSnaps: false,
  containScroll: true,
  align: "start",
});

const ingredientsDotsArray = generateDotBtns(ingredientsDots, ingredientsEmbla);
const setSelectedDotBtn = selectDotBtn(ingredientsDotsArray, ingredientsEmbla);

setupDotBtns(ingredientsDotsArray, ingredientsEmbla);

ingredientsEmbla.on("select", setSelectedDotBtn);
ingredientsEmbla.on("init", setSelectedDotBtn);

document.querySelector(".see-full-ingredients-button").onclick = () => {
  basicLightbox
    .create(document.querySelector(".ingredients-list"), {
      onShow: (instance) => {
        instance
          .element()
          .querySelector(".ingredients-list-close-btn").onclick =
          instance.close;
      },
    })
    .show();
};
